import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { Chart } from 'primereact/chart';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { FilterMatchMode } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import axios from "axios";
import { triggerAlert } from "utils/CommonFunctions";
import { Calendar } from 'primereact/calendar';
import { useSelector, useDispatch } from "react-redux";
import { setPageData } from "store/actions";
import CompanySelector from "ATSComponents/Common/CompanySelector";
import { useNavigate } from "react-router-dom";

const RecruiterDashboard = () => {
    const dispatch = useDispatch();
    const navigate= useNavigate()
    const { first, rows, totalRecords } = useSelector((state) => state.calendar.pagination);
    document.title = "ATS - Recruiter Dashboard";

    // Departments Dropdown
    const [departments, setDepartments] = useState([]);
    const [selectedValues, setSelectedValues] = useState({ name: 'All Departments', key: '' });
    const [selectedRange, setSelectedRange] = useState({ name: 'Custom Range', keyID: 'custom' });
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [dateError, setDateError] = useState(null);
     const userInfos = JSON.parse(sessionStorage.getItem("user-info"));
    const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
    const [companyId, setCompanyId] = useState(intialcompanyId);
  
    const handleCompanyChange = (company) => {
      if (company?.company_id) {
          setCompanyId(company?.company_id);
          // fetchUserManagementDetails(company.company_i)
          // getDesignation(company.company_id);
      }
    };

    const values = [
        { name: 'All Departments', key: '' },
        ...departments.map(dept => ({ name: dept.name, key: dept.department_id.toString() }))
    ];

    const ranges = [
        { name: 'Custom Range', keyID: 'custom' },
        { name: 'This Week', keyID: 'this_week' },
        { name: 'Last 30 Days', keyID: '30_days' },
        { name: 'One Year', keyID: 'one_year' }
    ];

    const fetchDepartments = async (id) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/get-all-departments/?company_id=${id}`);
            setDepartments(response?.data?.results);
        } catch (error) {
            triggerAlert('error', "Something went wrong", error.message);
        }
    };

    useEffect(() => {
        fetchDepartments(companyId);
    }, []);

    // Dashboard Data
    const [dashboardData, setDashboardData] = useState([]);
    const [recruitmentTrends, setRecruitmentTrends] = useState([]);
    const [openJobs, setOpenJobs] = useState([]);
    const [userActivityDetails, setUserActivityDetails] = useState([]);
    const [loading, setLoading] = useState(false);

    // const fetchDashboardList = async (id, filterType, startDate = null, endDate = null,ID) => {
    //     try {
    //         let response;
    //         if (filterType === 'custom' && startDate && endDate) {
    //             const formattedStartDate = startDate.toISOString().split('T')[0];
    //             const formattedEndDate = endDate.toISOString().split('T')[0];
    //             response = await axios.get(
    //                 `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/stats/??company_id=${ID}&department_id=${id}&filter_type=${filterType}&start_date=${formattedStartDate}&end_date=${formattedEndDate}`
    //             );
    //         } else {
    //             response = await axios.get(
    //                 `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/stats/?company_id=${ID}&department_id=${id}&filter_type=${filterType}`
    //             );
    //         }
    //         setDashboardData(response.data);
    //     } catch (error) {
    //         console.log(error.message);
    //     }
    // };

    // const fetchRecruitmentTrendsData = async (id, filterType, startDate = null, endDate = null,ID) => {
    //     try {
    //         let response;
    //         if (filterType === 'custom' && startDate && endDate) {
    //             const formattedStartDate = startDate.toISOString().split('T')[0];
    //             const formattedEndDate = endDate.toISOString().split('T')[0];
    //             response = await axios.get(
    //                 `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/recruitment-trends/?company_id=${ID}&department_id=${id}&filter_type=${filterType}&start_date=${formattedStartDate}&end_date=${formattedEndDate}`
    //             );
    //         } else {
    //             response = await axios.get(
    //                 `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/recruitment-trends/?company_id=${ID}&department_id=${id}&filter_type=${filterType}`
    //             );
    //         }
    //         setRecruitmentTrends(response?.data);
    //     } catch (error) {
    //         console.log("Error", error.message);
    //     }
    // };
const fetchDashboardList = async (id, filterType, startDate = null, endDate = null, ID) => {
    try {
        let response;
        if (filterType === 'custom' && startDate && endDate) {
            const offset = startDate.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
            const adjustedStartDate = new Date(startDate.getTime() - offset);
            const adjustedEndDate = new Date(endDate.getTime() - offset);

            const formattedStartDate = adjustedStartDate.toISOString().split('T')[0];
            const formattedEndDate = adjustedEndDate.toISOString().split('T')[0];

            response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/stats/?company_id=${ID}&department_id=${id}&filter_type=${filterType}&start_date=${formattedStartDate}&end_date=${formattedEndDate}`
            );
        } else {
            response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/stats/?company_id=${ID}&department_id=${id}&filter_type=${filterType}`
            );
        }
        setDashboardData(response.data);
    } catch (error) {
        console.log(error.message);
    }
};

    const fetchRecruitmentTrendsData = async (id, filterType, startDate = null, endDate = null, ID) => {
    try {
        let response;
        if (filterType === 'custom' && startDate && endDate) {
            const offset = startDate.getTimezoneOffset() * 60000;
            const adjustedStartDate = new Date(startDate.getTime() - offset);
            const adjustedEndDate = new Date(endDate.getTime() - offset);

            const formattedStartDate = adjustedStartDate.toISOString().split('T')[0];
            const formattedEndDate = adjustedEndDate.toISOString().split('T')[0];

            response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/recruitment-trends/?company_id=${ID}&department_id=${id}&filter_type=${filterType}&start_date=${formattedStartDate}&end_date=${formattedEndDate}`
            );
        } else {
            response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/recruitment-trends/?company_id=${ID}&department_id=${id}&filter_type=${filterType}`
            );
        }
        setRecruitmentTrends(response?.data);
    } catch (error) {
        console.log("Error", error.message);
    }
};

    // const fetchRecentOpenJobs = async (id, filterType, startDate, endDate,ID) => {
    //     try {
    //         setLoading(true);
    //         let response;
    //         if (filterType === 'custom' && startDate && endDate) {
    //             const formattedStartDate = startDate.toISOString().split('T')[0];
    //             const formattedEndDate = endDate.toISOString().split('T')[0];
    //             response = await axios.get(
    //                 `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/recent-open-jobs/?company_id=${ID}&department_id=${id}&filter_type=${filterType}&start_date=${formattedStartDate}&end_date=${formattedEndDate}`
    //             );
    //         } else {
    //             response = await axios.get(
    //                 `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/recent-open-jobs/?company_id=${ID}&department_id=${id}&filter_type=${filterType}`
    //             );
    //         }

    //         const jobsData = response?.data || [];
    //         dispatch(setPageData({
    //             first: 0,
    //             rows: rows,
    //             totalRecords: jobsData.length
    //         }));
    //         const startIndex = 0;
    //         const endIndex = first + rows;
    //         const paginatedJobs = jobsData.slice(startIndex, endIndex);
    //         setOpenJobs(paginatedJobs);
    //     } catch (error) {
    //         triggerAlert("error", "Failed to fetch recent open jobs", error.message);
    //     } finally {
    //         setLoading(false);
    //     }
    // };
const fetchRecentOpenJobs = async (id, filterType, startDate, endDate, ID) => {
    try {
        setLoading(true);
        let response;
        if (filterType === 'custom' && startDate && endDate) {
            const offset = startDate.getTimezoneOffset() * 60000;
            const adjustedStartDate = new Date(startDate.getTime() - offset);
            const adjustedEndDate = new Date(endDate.getTime() - offset);

            const formattedStartDate = adjustedStartDate.toISOString().split('T')[0];
            const formattedEndDate = adjustedEndDate.toISOString().split('T')[0];

            response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/recent-open-jobs/?company_id=${ID}&department_id=${id}&filter_type=${filterType}&start_date=${formattedStartDate}&end_date=${formattedEndDate}`
            );
        } else {
            response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/recent-open-jobs/?company_id=${ID}&department_id=${id}&filter_type=${filterType}`
            );
        }

        const jobsData = response?.data || [];
        dispatch(setPageData({
            first: 0,
            rows: rows,
            totalRecords: jobsData.length
        }));
        const startIndex = 0;
        const endIndex = first + rows;
        const paginatedJobs = jobsData.slice(startIndex, endIndex);
        setOpenJobs(paginatedJobs);
    } catch (error) {
        triggerAlert("error", "Failed to fetch recent open jobs", error.message);
    } finally {
        setLoading(false);
    }
};

    // const fetchUserActivityComparison = async (filterType, startDate, endDate,id) => {
    //     try {
    //         setLoading(true);
    //         let response;
    //         if (filterType === 'custom' && startDate && endDate) {
    //             const formattedStartDate = startDate.toISOString().split('T')[0];
    //             const formattedEndDate = endDate.toISOString().split('T')[0];
    //             response = await axios.get(
    //                 `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/user-activity-comparison/?company_id=${id}&filter_type=${filterType}&start_date=${formattedStartDate}&end_date=${formattedEndDate}`
    //             );
    //         } else {
    //             response = await axios.get(
    //                 `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/user-activity-comparison/?company_id=${id}&filter_type=${filterType}`
    //             );
    //         }
    //         setUserActivityDetails(response?.data);
    //     } catch (error) {
    //         triggerAlert('error', "Something Went Wrong", error.message);
    //     } finally {
    //         setLoading(false);
    //     }
    // };
const fetchUserActivityComparison = async (filterType, startDate, endDate, id) => {
    try {
        setLoading(true);
        let response;
        if (filterType === 'custom' && startDate && endDate) {
            const offset = startDate.getTimezoneOffset() * 60000;
            const adjustedStartDate = new Date(startDate.getTime() - offset);
            const adjustedEndDate = new Date(endDate.getTime() - offset);

            const formattedStartDate = adjustedStartDate.toISOString().split('T')[0];
            const formattedEndDate = adjustedEndDate.toISOString().split('T')[0];

            response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/user-activity-comparison/?company_id=${id}&filter_type=${filterType}&start_date=${formattedStartDate}&end_date=${formattedEndDate}`
            );
        } else {
            response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/user-activity-comparison/?company_id=${id}&filter_type=${filterType}`
            );
        }
        setUserActivityDetails(response?.data);
    } catch (error) {
        triggerAlert('error', "Something Went Wrong", error.message);
    } finally {
        setLoading(false);
    }
};
useEffect(() => {
    // Reset all filter-related states to default values
    setSelectedValues({ name: 'All Departments', key: '' });
    setSelectedRange({ name: 'Custom Range', keyID: 'custom' });
    setStartDate(null);
    setEndDate(null);
    setDateError(null);
}, []); // Empty dependency array ensures this runs only once on component mount

    useEffect(() => {
        fetchDashboardList(selectedValues?.key, selectedRange?.keyID, startDate, endDate,companyId);
        fetchRecentOpenJobs(selectedValues?.key, selectedRange?.keyID, startDate, endDate,companyId);
        fetchRecruitmentTrendsData(selectedValues?.key, selectedRange?.keyID, startDate, endDate,companyId);
        fetchUserActivityComparison(selectedRange?.keyID, startDate, endDate,companyId);
    }, [selectedValues, selectedRange, startDate, endDate, first, rows,companyId]);

    // Charts Data
    const [cansourcedata, setCansourcedata] = useState({});
    const [cansourceoptions, setCansourceoptions] = useState({});
    const [recruiterActivitiesData, setRecruiterActivitiesData] = useState({});
    const [recruiterActivitiesOptions, setRecruiterActivitiesOptions] = useState({});
    const [recruitmentData, setRecruitmentData] = useState({});
    const [recruitmentOptions, setRecruitmentOptions] = useState({});

    // Candidate Source Distribution
    useEffect(() => {
        if (!dashboardData?.candidate_source || dashboardData.candidate_source.length === 0) return;
        const documentStyle = getComputedStyle(document.documentElement);
        const labels = dashboardData.candidate_source.map(item => item?.source || 'Unknown');
        const datavalues = dashboardData.candidate_source.map(item => item?.count || 0);
        const colorPalette = [
            '--blue-500', '--yellow-500', '--green-500', '--purple-500',
            '--red-500', '--orange-500', '--cyan-500', '--pink-500',
            '--teal-500', '--indigo-500'
        ];
        const backgroundColor = labels.map((_, index) =>
            documentStyle.getPropertyValue(colorPalette[index % colorPalette.length])
        );
        const hoverBackgroundColor = labels.map((_, index) =>
            documentStyle.getPropertyValue(colorPalette[index % colorPalette.length].replace('-500', '-400'))
        );
        const data = {
            labels: labels,
            datasets: [{
                data: datavalues,
                backgroundColor: backgroundColor,
                hoverBackgroundColor: hoverBackgroundColor
            }]
        };
        const options = {
            plugins: {
                legend: {
                    labels: {
                        usePointStyle: true
                    }
                }
            }
        };
        setCansourcedata(data);
        setCansourceoptions(options);
    }, [dashboardData]);

    // Recruiter Team Activities
    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
        const labelsData = dashboardData?.stage_data?.map((item) => item?.stage);
        const datalabels = dashboardData?.stage_data?.map((item) => item?.count);
        const maxCount = datalabels?.length > 0 ? Math.max(...datalabels) : 100;
        const stepSize = Math.ceil(maxCount / 10) * 2;
        const suggestedMax = Math.ceil(maxCount * 1.2);
        const data = {
            labels: labelsData,
            datasets: [{
                label: 'Recruiter Activities',
                backgroundColor: '#669abb',
                borderColor: documentStyle.getPropertyValue('--blue-500'),
                data: datalabels
            }]
        };
        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                        font: {
                            weight: 500
                        },
                        align: 'center',
                        padding: 5,
                        maxRotation: 45,
                        minRotation: 45,
                        autoSkip: false
                    },
                    grid: {
                        display: false,
                        drawBorder: false
                    }
                },
                y: {
                    ticks: {
                        stepSize: stepSize,
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    },
                    suggestedMin: 0,
                    suggestedMax: suggestedMax
                }
            }
        };
        setRecruiterActivitiesData(data);
        setRecruiterActivitiesOptions(options);
    }, [dashboardData]);

    // Recruitment Trends
    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
        const monthNames = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const labelsData = recruitmentTrends.map(item => {
            const monthIndex = parseInt(item.month.split('-')[1], 10) - 1;
            return monthNames[monthIndex];
        });
        const applicationData = recruitmentTrends?.map(item => item?.candidate_count);
        const interviewsData = recruitmentTrends?.map(item => item?.interview_completed_count);
        const data = {
            labels: labelsData,
            datasets: [
                {
                    label: 'Applications',
                    data: applicationData,
                    fill: false,
                    borderColor: documentStyle.getPropertyValue('--blue-500'),
                    tension: 0.4
                },
                {
                    label: 'Interviews',
                    data: interviewsData,
                    fill: false,
                    borderColor: documentStyle.getPropertyValue('--pink-500'),
                    tension: 0.4
                }
            ]
        };
        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.6,
            plugins: {
                tooltip: {
                    callbacks: {
                        label: function (context) {
                            const datasetLabel = context.dataset.label || '';
                            const value = context.raw || 0;
                            return `${datasetLabel}: ${value}`;
                        },
                        footer: function (tooltipItems) {
                            const index = tooltipItems[0].dataIndex;
                            const applications = data.datasets[0].data[index];
                            const interviews = data.datasets[1].data[index];
                            return `Applications: ${applications} | Interviews: ${interviews}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                },
                y: {
                    ticks: {
                        color: textColorSecondary,
                        stepSize: 10
                    },
                    grid: {
                        color: surfaceBorder
                    },
                    suggestedMin: 0,
                    suggestedMax: 90
                }
            }
        };
        setRecruitmentData(data);
        setRecruitmentOptions(options);
    }, [recruitmentTrends]);

    // Open Jobs Table
    const [openjobfilters, setopenjobfilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        job_number: { value: null, matchMode: FilterMatchMode.CONTAINS },
        job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        job_status_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        openings: { value: null, matchMode: FilterMatchMode.EQUALS },
        hiring_manager_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        company_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        location_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        workplace_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        job_type_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        preferred_skill_names: { value: null, matchMode: FilterMatchMode.CONTAINS },
        required_skill_names: { value: null, matchMode: FilterMatchMode.CONTAINS },
        required_experience: { value: null, matchMode: FilterMatchMode.EQUALS },
        salary_min: { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        salary_max: { value: null, matchMode: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
        department_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        job_start_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
        job_end_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
        education_level: { value: null, matchMode: FilterMatchMode.CONTAINS },
        application_deadline: { value: null, matchMode: FilterMatchMode.CONTAINS },
        job_posting_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
        job_closing_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const [selectedJobs, setSelectedJobs] = useState([]);

    const onPage = (e) => {
        dispatch(setPageData({
            first: e.first,
            rows: e.rows,
            totalRecords: totalRecords
        }));
    };

    const handleEndDateChange = (e) => {
        const newEndDate = e.value;
        if (startDate && newEndDate && newEndDate < startDate) {
            setDateError("End date cannot be earlier than start date");
            setEndDate(null);
        } else {
            setDateError(null);
            setEndDate(newEndDate);
        }
    };
// Add this useEffect to trigger API calls when startDate changes
useEffect(() => {
    if (startDate) {
        fetchDashboardList(selectedValues?.key, selectedRange?.keyID, startDate, endDate, companyId);
        fetchRecentOpenJobs(selectedValues?.key, selectedRange?.keyID, startDate, endDate, companyId);
        fetchRecruitmentTrendsData(selectedValues?.key, selectedRange?.keyID, startDate, endDate, companyId);
        fetchUserActivityComparison(selectedRange?.keyID, startDate, endDate, companyId);
    }
}, [startDate]);

// Replace your current useEffect with this one for parallel API calls
useEffect(() => {
    (async () => {
        try {
            setLoading(true);
            await Promise.all([
                fetchDashboardList(selectedValues?.key, selectedRange?.keyID, startDate, endDate, companyId),
                fetchRecentOpenJobs(selectedValues?.key, selectedRange?.keyID, startDate, endDate, companyId),
                fetchRecruitmentTrendsData(selectedValues?.key, selectedRange?.keyID, startDate, endDate, companyId),
                fetchUserActivityComparison(selectedRange?.keyID, startDate, endDate, companyId),
            ]);
        } catch (error) {
            triggerAlert('error', "Failed to fetch data", error.message);
        } finally {
            setLoading(false);
        }
    })();
}, [selectedValues, selectedRange, startDate, endDate, first, rows, companyId]);
const handleStartDateChange = (e) => {
    const newStartDate = e.value;
    setStartDate(newStartDate);
    // Optionally reset department or range filter
    // setSelectedValues({ name: 'All Departments', key: '' });
    // setSelectedRange({ name: 'Custom Range', keyID: 'custom' });
};

    return (
        <React.Fragment>
            <div className="page-content allact-tabs">
                <Container fluid={true}>
                    <div className="page-title-box mb-0 recruiter-dashboard actjobsum">
                      <Row className="align-items-center justify-content-between mb-3">
                        <Col xs="auto">
                            <h1 className="page-title mb-0">Recruiter Dashboard</h1>
                        </Col>
                        <Col xs="auto">
                            <div style={{ width: "200px" }}>
                            <CompanySelector onCompanyChange={handleCompanyChange} />
                            </div>
                        </Col>
                        </Row>
                        <Row>
                            <Col lg={3} md={6} className="mb-4">
                                <Dropdown
                                    value={selectedValues}
                                    onChange={(e) => setSelectedValues(e.value)}
                                    options={values}
                                    optionLabel="name"
                                    placeholder="All Departments"
                                    className="w-full bgclr me-2"
                                    checkmark={true}
                                    highlightOnSelect={false}
                                />
                            </Col>
                            <Col lg={3} md={6} className="mb-4">
                                <Dropdown
                                    value={selectedRange}
                                    onChange={(e) => setSelectedRange(e.value)}
                                    options={ranges}
                                    optionLabel="name"
                                    placeholder="Custom Range"
                                    className="w-full bgclr"
                                    checkmark={true}
                                    highlightOnSelect={false}
                                />
                            </Col>
                             {selectedRange?.keyID === 'custom' && (
                                <>
                                <Col lg={3} md={6} className="mb-4">
                                    <Calendar
                                        value={startDate}
                                        onChange={handleStartDateChange}
                                        placeholder="Start Date"
                                        className="w-full bgclr"
                                        showIcon
                                        dateFormat="dd-mm-yy"
                                    />
                                </Col>
                                <Col lg={3} md={6} className="mb-4">
                                    <Calendar
                                        value={endDate}
                                        onChange={handleEndDateChange}
                                        placeholder="End Date"
                                        className={`w-full bgclr ${dateError ? 'p-invalid' : ''}`}
                                        showIcon
                                        dateFormat="dd-mm-yy"
                                    />
                                    {dateError && <small className="p-error">{dateError}</small>}
                                </Col>
                            </>
                        )}
                           
                        </Row>
                        <Row>
                            <Col lg={3} className="mb-4">
                                <Card className="h-100" onClick={()=>navigate("/all-job-orders")} style={{cursor:"pointer"}}>
                                    <p className="smalltitle">Total Openings</p>
                                    <div className="d-flex justify-content-between">
                                        <h3 className="smallhead">{dashboardData?.job_count}</h3>
                                        <span>
                                            {dashboardData?.job_count_change > 0 ? (
                                                <i className="pi pi-arrow-up me-2 success-txt" style={{ color: 'green' }}></i>
                                            ) : dashboardData?.job_count_change < 0 ? (
                                                <i className="pi pi-arrow-down me-2 danger-txt" style={{ color: 'red' }}></i>
                                            ) : null}
                                            {dashboardData?.job_count_change > 0 && "+"}
                                            {dashboardData?.job_count_change}
                                            {dashboardData?.job_count_change !== undefined && "%"}
                                        </span>
                                    </div>
                                </Card>
                            </Col>
                            <Col lg={3} className="mb-4">
                                <Card className="h-100" onClick={()=>navigate("/all_referral_candidates")} style={{cursor:"pointer"}}>
                                    <p className="smalltitle">Applications</p>
                                    <div className="d-flex justify-content-between">
                                        <h3 className="smallhead">{dashboardData?.received_applications}</h3>
                                        <span>
                                            {dashboardData?.received_applications_change > 0 ? (
                                                <i className="pi pi-arrow-up me-2 success-txt" style={{ color: 'green' }}></i>
                                            ) : dashboardData?.received_applications_change < 0 ? (
                                                <i className="pi pi-arrow-down me-2 danger-txt" style={{ color: 'red' }}></i>
                                            ) : null}
                                            {dashboardData?.received_applications_change > 0 && "+"}
                                            {dashboardData?.received_applications_change}
                                            {dashboardData?.received_applications_change !== undefined && "%"}
                                        </span>
                                    </div>
                                </Card>
                            </Col>
                            <Col lg={3} className="mb-4">
                                <Card className="h-100" onClick={()=>navigate("/all-calendar")} style={{cursor:"pointer"}}>
                                    <p className="smalltitle">Interviews</p>
                                    <div className="d-flex justify-content-between">
                                        <h3 className="smallhead">{dashboardData?.interview_scheduled}</h3>
                                        <span>
                                            {dashboardData?.interview_scheduled_change > 0 ? (
                                                <i className="pi pi-arrow-up me-2 success-txt" style={{ color: 'green' }}></i>
                                            ) : dashboardData?.interview_scheduled_change < 0 ? (
                                                <i className="pi pi-arrow-down me-2 danger-txt" style={{ color: 'red' }}></i>
                                            ) : null}
                                            {dashboardData?.interview_scheduled_change > 0 && "+"}
                                            {dashboardData?.interview_scheduled_change}
                                            {dashboardData?.interview_scheduled_change !== undefined && "%"}
                                        </span>
                                    </div>
                                </Card>
                            </Col>
                            <Col lg={3} className="mb-4">
                                <Card className="h-100" onClick={()=>navigate("/Kanbanview")} style={{cursor:"pointer"}}>
                                    <p className="smalltitle">Offers Extended</p>
                                    <div className="d-flex justify-content-between">
                                        <h3 className="smallhead">{dashboardData?.offer_accepted}</h3>
                                        <span>
                                            {dashboardData?.offer_accepted_change > 0 ? (
                                                <i className="pi pi-arrow-up me-2 success-txt" style={{ color: 'green' }}></i>
                                            ) : dashboardData?.offer_accepted_change < 0 ? (
                                                <i className="pi pi-arrow-down me-2 danger-txt" style={{ color: 'red' }}></i>
                                            ) : null}
                                            {dashboardData?.offer_accepted_change > 0 && "+"}
                                            {dashboardData?.offer_accepted_change}
                                            {dashboardData?.offer_accepted_change !== undefined && "%"}
                                        </span>
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={4} className="mb-4">
                                <Card className="h-100">
                                    <h1 className="title">Candidate Source Distribution</h1>
                                    <Chart type="pie" data={cansourcedata} options={cansourceoptions} className="w-full" />
                                </Card>
                            </Col>
                            
                            <Col lg={4} className="mb-4">
                                <Card className="h-70">
                                    <h1 className="title">Recruiter Team Activities</h1>
                                    <Chart type="bar" data={recruiterActivitiesData} options={recruiterActivitiesOptions} />
                                </Card>
                            </Col>
                        
                            <Col lg={4} className="mb-4">
                                <Card className="h-100">
                                    <h1 className="title">Recruitment Trends</h1>
                                    <Chart type="line" data={recruitmentData} options={recruitmentOptions} />
                                </Card>
                            </Col>
                        </Row>
                         <Row>
                                                        <Col lg={12} className="mb-4">
                                                            <div className="mandashtable1">
                                                                <Card className="h-100">
                                                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                                                        <h1 className="title">Recent Open Jobs</h1>
                                                                        {/* <Dropdown
                                                                            value={selectedPeriod}
                                                                            onChange={(e) => setSelectedPeriod(e.value)}
                                                                            options={periods}
                                                                            optionLabel="name"
                                                                            placeholder="Select a Period"
                                                                            className="md:w-10rem bgclr"
                                                                        /> */}
                                                                    </div>
                        
                        
                                                                    <div className="card1 actjobsumtable" id="RecentOpenJobs_TableView">
                                                                        <DataTable
                                                                            value={openJobs}
                                                                            dataKey="job_number"
                                                                            scrollable
                                                                            scrollHeight="500px" 
                                                                            filters={openjobfilters}
                                                                            // filterDisplay="row"
                                                                            globalFilterFields={[
                                                                                "job_number",
                                                                                "job_title",
                                                                                "job_status_name",
                                                                                "openings",
                                                                                "hiring_manager_name",
                                                                                "company_name",
                                                                                "location_name",
                                                                                "workplace_name",
                                                                                "job_type_name",
                                                                                "preferred_skill_names",
                                                                                "required_skill_names",
                                                                                "required_experience",
                                                                                "salary_min",
                                                                                "salary_max",
                                                                                "department_name",
                                                                                "job_start_date",
                                                                                "job_end_date",
                                                                                "education_level",
                                                                                "application_deadline",
                                                                                "job_posting_date",
                                                                                "job_closing_date"
                        
                                                                            ]}
                                                                            
                                                                            emptyMessage="No open jobs found."
                                                                            selection={selectedJobs}
                                                                            // onSelectionChange={(e) => setSelectedJobs(e.value)}
                                                                            selectionMode="multiple"
                                                                            
                                                                            columnResizeMode="expand"
                                                                            first={first}
                                                                            totalRecords={totalRecords}
                                                                            rows={rows}
                                                                            onPage={onPage}
                                                                        >
                                                                            {/* <Column selectionMode="multiple" headerStyle={{ width: "3em" }}/> */}
                                                                            <Column field="job_number" header="Job ID" sortable  style={{ minWidth: "10rem" }}  />
                                                                            {/* <Column field="job_title" header="Job Title" sortable  style={{ minWidth: "10rem" }}  /> */}
                                                                            <Column
                                                                                field="job_title"
                                                                                header="Job Title"
                                                                                sortable
                                                                                style={{ minWidth: "12rem" }}
                                                                                body={(rowData) => (
                                                                                    <span title={rowData.job_title}>
                                                                                    {rowData.job_title}
                                                                                    </span>
                                                                                )}
                                                                                />
                        
                                                                            <Column field="job_status_name" header="Job Status" sortable  style={{ minWidth: "10rem" }}  />
                                                                            {/* <Column field="job_posting_date" header="Job Posting Date" sortable filter style={{ minWidth: "10rem" }}  filterPlaceholder="Job posting date"/>
                                                                            <Column field="job_closing_date" header="Last Day To Apply Job" sortable filter style={{ minWidth: "10rem" }}  filterPlaceholder="Job closing date"/> */}
                                                                            <Column field="openings" header="Openings" sortable  style={{ minWidth: "8rem" }}  />
                                                                            {/* <Column field="recruiters_names" header="Hiring Manager" sortable  style={{ minWidth: "12rem" }}  /> */}
                                                                            <Column
                                                                                header="Hiring Manager"
                                                                                sortable
                                                                                body={(rowData) => {
                                                                                    const names = Array.isArray(rowData.recruiters_names)
                                                                                    ? rowData.recruiters_names.join(", ")
                                                                                    : rowData.recruiters_names || "-";
                        
                                                                                    return (
                                                                                    <span title={names}>
                                                                                        {names}
                                                                                    </span>
                                                                                    );
                                                                                }}
                                                                                />
                        
                                                                            {/* <Column field="company_name" header="Company" sortable  style={{ minWidth: "10rem" }}  /> */}
                                                                            <Column
                                                                                field="company_name"
                                                                                header="Company"
                                                                                sortable
                                                                                style={{ minWidth: "12rem" }}
                                                                                body={(rowData) => (
                                                                                    <span title={rowData.company_name}>
                                                                                    {rowData.company_name}
                                                                                    </span>
                                                                                )}
                                                                                />
                        
                                                                            <Column field="location" header="Job Location" sortable  style={{ minWidth: "12rem" }}  />
                                                                            {/* <Column field="workplace_name" header="Workplace Type" sortable filter style={{ minWidth: "10rem" }}  filterPlaceholder="workplace"/> */}
                                                                                <Column
                                                                                header="Job Type"
                                                                                sortable
                                                                                style={{ minWidth: "8rem" }}
                                                                                body={(rowData) => {
                                                                                    const jobType = rowData.job_type_name || "-";
                                                                                    return (
                                                                                    <span title={jobType}>
                                                                                        Full Time
                                                                                    </span>
                                                                                    );
                                                                                }}
                                                                                />                                      
                                                                            {/* <Column field="skills" header="Preferred Skills" body={(rowData) => Array.isArray(rowData.skills) ? rowData.skills.join(',') : rowData.skills} sortable  style={{ minWidth: "15rem" }}  /> */}
                                                                            <Column
                                                                                    header="Preferred Skills"
                                                                                    sortable
                                                                                    style={{ minWidth: "18rem" }}
                                                                                    body={(rowData) => {
                                                                                        const skills = Array.isArray(rowData.skills)
                                                                                        ? rowData.skills.join(", ")
                                                                                        : rowData.skills || "-";
                        
                                                                                        return (
                                                                                        <span title={skills}>
                                                                                            {skills}
                                                                                        </span>
                                                                                        );
                                                                                    }}
                                                                                    />
                        
                                                                            {/* <Column field="required_skill_names" header="Required Skills" body={(rowData) => Array.isArray(rowData.skills) ? rowData.skills.join(',') : rowData.skills} sortable  style={{ minWidth: "15rem" }} /> */}
                                                                            <Column
                                                                                header="Required Skills"
                                                                                sortable
                                                                                style={{ minWidth: "18rem" }}
                                                                                body={(rowData) => {
                                                                                    const skills = Array.isArray(rowData.skills)
                                                                                    ? rowData.skills.join(", ")
                                                                                    : rowData.skills || "-";
                        
                                                                                    return (
                                                                                    <span title={skills}>
                                                                                        {skills}
                                                                                    </span>
                                                                                    );
                                                                                }}
                                                                                />
                        
                                                                            {/* <Column field="min_exp" header="Experience Required" sortable  style={{ minWidth: "10rem" }} /> */}
                                                                            {/* <Column field="salary_min" header="Min Salary" sortable filter style={{ minWidth: "10rem" }}   filterPlaceholder="minimum salary"/>
                                                                            <Column field="salary_max" header="Max Salary" sortable filter style={{ minWidth: "10rem" }}   filterPlaceholder="maximum salary"/> */}
                                                                            {/* <Column field="department_name" header="Department" sortable filter style={{ minWidth: "10rem" }}   filterPlaceholder="department name"/> */}
                                                                            {/* <Column field="job_start_date" header="Job Start Date" sortable filter style={{ minWidth: "10rem" }}   filterPlaceholder="job start date"/>
                                                                            <Column field="job_end_date" header="Job End Date" sortable filter style={{ minWidth: "10rem" }}   filterPlaceholder="job end date"/> */}
                                                                            {/* <Column field="education_level" header="Education" sortable filter style={{ minWidth: "10rem" }}   filterPlaceholder="education"/> */}
                                                                            <Column
                                                                            header="Experience Required"
                                                                            sortable
                                                                            style={{ minWidth: "12rem" }}
                                                                            body={(rowData) => {
                                                                                const min = rowData.min_exp;
                                                                                const max = rowData.max_exp;
                        
                                                                                const expText =
                                                                                min && max ? `${min} - ${max} Years` :
                                                                                min ? `${min} Years` :
                                                                                max ? `${max} Years` : "-";
                        
                                                                                return (
                                                                                <span title={expText}>
                                                                                    {expText}
                                                                                </span>
                                                                                );
                                                                            }}
                                                                            />
                                                                           <Column
                                                                            header="Application Deadline"
                                                                            sortable
                                                                            style={{ minWidth: "10rem" }}
                                                                            body={(rowData) => {
                                                                                const rawDate = rowData.close_date;
                        
                                                                                if (!rawDate) return <span>-</span>;
                        
                                                                                const dateObj = new Date(rawDate);
                        
                                                                                const formattedDate = dateObj.toLocaleDateString("en-GB", {
                                                                                day: "2-digit",
                                                                                month: "2-digit",
                                                                                year: "numeric",
                                                                                });
                        
                                                                                return (
                                                                                <span title={formattedDate}>
                                                                                    {formattedDate}
                                                                                </span>
                                                                                );
                                                                            }}
                                                                            />
                        
                                                                            </DataTable>
                                                                    </div>
                                                                </Card>
                        
                                                            </div>
                                                        </Col>
                                                    </Row>
                        {/* <Row>
                            <Col lg={6} className="mb-4">
                                <Card className="h-70">
                                    <h1 className="title">Recruiter Team Activities</h1>
                                    <Chart type="bar" data={recruiterActivitiesData} options={recruiterActivitiesOptions} />
                                </Card>
                            </Col>
                        </Row> */}
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default RecruiterDashboard;
